export default "__VITE_ASSET__78cb2fb9__"